import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
  <footer className="site-footer">
  <div className="container grid-xl">
  <div className="columns site-footer-nav">
    <div className="col-3 col-md-12">
      <Link className="footer-logo" to="/">
        <img width="130" src={require('../../images/duvel_logo_footer.png')} />
      </Link>
    </div>
    <div className="col-9 col-md-12">
      <div className="site-footer-nav">
      <span className="site-footer-line btn-light-grey"> © 小西酒造株式会社 - Duvel Moortgat NV. - All Rights Reserved</span>
<Link className="site-footer-link btn-light-grey" activeClassName="active" to="/terms">ご利用規約</Link> | <Link className="site-footer-link btn-light-grey" activeClassName="active" to="/privacy">プライバシーポリシー</Link> | <Link className="site-footer-link btn-light-grey" activeClassName="active" to="/contact">お問い合わせ</Link>
<span className="site-footer-line btn-light-grey">お酒は20歳になってから。おいしく適量を。</span>
    </div></div>
  </div>
  </div>
  </footer>
)

export default Header




// WEBPACK FOOTER //
// ./src/components/Footer/index.js